import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'users',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  getURL: 'users',
  emptyMessage: "You don't have contents, visit the content section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canFilter: true,
      helpText: 'Name of the user.',
    },
    {
      attributeName: 'email',
      label: 'Email',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canFilter: true,
      helpText: 'Email of the user',
    },
  ],
};
